export enum Constants {
  EDIT_DOCUMENT_INTRO_HAS_PLAYED = 'edit-document-intro-has-played',
  SUPPORT_PORTAL_BASE_URL = 'https://blabberjax.atlassian.net/wiki/spaces/BKP/',
  SUPPORT_TICKET_URL = 'https://airtable.com/appETyqdO92stApnJ/shryhk17IkZbra8ms'
}

export interface PartialHeadingInfo {
  shortDescription: string;
  helpLink: string;
  helpLinkText: string;
}

const HeadingInfoSet: {
  Themes: PartialHeadingInfo,
  Articles: PartialHeadingInfo,
  SocialSetup: PartialHeadingInfo,
  Webhooks: PartialHeadingInfo,
  Projects: PartialHeadingInfo,
  SeoSetup: PartialHeadingInfo,
  ContentGraph: PartialHeadingInfo,
  PromptChains: PartialHeadingInfo,
  Welcome: PartialHeadingInfo,
  TopicExplorer: PartialHeadingInfo
} = {
  Themes: {
    shortDescription: 'Use themes to organize your content or add a target date to them to treat them like campaigns.',
    helpLink: '',
    helpLinkText: ''
  },
  Articles: {
    shortDescription: 'This is your content schedule, divided up by project.  Use the dropdown on the top right to quickly switch to another project workspace.',
    helpLink: '',
    helpLinkText: ''
  },
  SocialSetup: {
    shortDescription: 'Click on the buttons below to authenticate to all of your social media accounts.',
    helpLink: '',
    helpLinkText: ''
  },
  Webhooks: {
    shortDescription: 'For more information about setting up a webhook, including sample source code please read our ',
    helpLink: 'https://blabberjax.atlassian.net/wiki/x/AYCrGQ',
    helpLinkText: 'API & Webhooks Guide.'
  },
  Projects: {
    shortDescription: '',
    helpLink: '',
    helpLinkText: ''
  },
  SeoSetup: {
    shortDescription: 'To get started with SEO analysis enter the URL for your website\'s sitemap. Please note that we currently only support analyzing a single sitemap for a website.',
    helpLink: '',
    helpLinkText: ''
  },
  ContentGraph: {
    shortDescription: 'This is a graph of all of the content in your sitemap and how it links together. Use the search bar below to filter by different keywords.',
    helpLink: '',
    helpLinkText: ''
  },
  PromptChains: {
    shortDescription: 'Prompt Chains are templatized messages sent to AI models to generate articles and other content.  From here you have complete access to customize how every piece of content is generated.',
    helpLink: '',
    helpLinkText: ''
  },
  Welcome: {
    shortDescription: "Welcome to BlabberJax! What's your primary goal?",
    helpLink: `${Constants.SUPPORT_PORTAL_BASE_URL}overview?utm_source=in-app&utm_medium=welcome-page`,
    helpLinkText: 'Support Portal'
  },
  TopicExplorer: {
    shortDescription: "Boost your SEO by building topic authority. The Topic Explorer helps you uncover gaps and expand your topical coverage.",
    helpLink: ``,
    helpLinkText: ''
  }
}

export const NavHeadings = Object.freeze(HeadingInfoSet);